var map = {
	"./bgwin.png": 92756,
	"./icon-minigame.png": 82894,
	"./iconBaucua.png": 5915,
	"./iconMinigame.png": 31945,
	"./iconXocdia.png": 18982,
	"./icongame-taixiu.png": 52543,
	"./text-minigame.png": 28484
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72858;